// extracted by mini-css-extract-plugin
export default {"wrapper":"K1-z","play":"L1-z"};